<app-sidebar></app-sidebar>

<div style="position: relative; left: 10px; top: 10px;">
  <div>
    <a (click)="deleteAccess()">تسجيل الخروج</a>
  </div>
</div>

<div class="add-list">
    <a class="vincent_button" (click)="basicModal3.show()">أضافة صورة</a>
</div>

<!-- add list modal -->
<div mdbModal #basicModal3="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal3.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">أضافة صورة جديدة</h4>
      </div>
      <div class="modal-body">
        <form #f1="ngForm" (ngSubmit)="addImg(f1)">
          <div class="md-form">
            <input mdbInput placeholder="picture's name" ngModel name="title" #title="ngModel" type="text"  class="form-control" required>
            <input mdbInput placeholder=" أسم صورة" ngModel name="title_ar" #title_ar="ngModel" type="text" class="form-control" required>
          </div>
          <div class="md-form">
            <input mdbInput placeholder=" picture's description  " ngModel name="description" #description="ngModel" type="text" class="form-control" required>
            <input mdbInput placeholder=" وصف صورة  " ngModel name="description_ar" #description_ar="ngModel" type="text" class="form-control" required>
          </div>
          <input mdbInput type="file" ngModel #photoUrl name="photoUrl" class="form-control" required>
          <input type="submit" value="أدخال" [disabled]="f1.invalid" style="margin-top: 20px;" *ngIf="addImgS == true">
          <div class="status" *ngIf="loading == true">
            <img src="assets/imgs/loading2.gif" style="width: 45px;">
          </div>
          <div class="status" *ngIf="done == true">
            <img src="assets/imgs/done.png" style="width: 45px;">
          </div>
        </form>            
      </div>
      <div class="modal-footer">
        <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal3.hide()" mdbWavesEffect>غلق</button>
      </div>
    </div>
  </div>
</div>
<!-- add list modal end-->

<div class="vincent_container vincent_typography">
    <div class="row gutters">
      <div class="col col-10 vincent_content">
    <table class="vincent_cart">
      <thead>
          <tr>
              <th></th>
              <th></th>
              <th><span>الوصف</span></th>
              <th><span>الأسم</span></th>
          </tr>
      </thead>
      <tbody>
          <tr class="vincent_cart_item" *ngFor="let info of imgs; index as i" style="border-bottom: none;">

                  <td>
                      <a class="" (click)="basicModal2.show()"><mdb-icon far icon="edit"></mdb-icon></a>
                  </td>
                  <td> 
                      <img [src]="info.photoUrl" style="width: 120px">
                  </td>
                  <td class="vincent_product-subtotal">
                    <a (click)="basicModal2222.show()">عرض الوصف</a>
                  </td>
                  <td class="vincent_product-subtotal">
                    <a (click)="basicModal222233.show()">عرض الأسم</a>
                  </td>

              <!-- edit item model-->
              <div mdbModal #basicModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2.hide()">
                        <span aria-hidden="true">×</span>
                      </button>
                      <h4 class="modal-title w-100" id="myModalLabel">تعديل الصورة</h4>
                    </div>
                    <div class="modal-body">
                      <div>
                        <div class="md-form">
                          <input mdbInput placeholder="picture's title" [(ngModel)]="info.title" type="text" class="form-control" (focus)="onFocus()">
                          <input mdbInput placeholder="أسم الصورة" [(ngModel)]="info.title_ar" type="text" class="form-control" (focus)="onFocus()">
                        </div>
                        <div class="md-form">
                          <input mdbInput placeholder="picture's description" [(ngModel)]="info.description" type="text" class="form-control" (focus)="onFocus()">
                          <input mdbInput placeholder=" وصف الصورة" [(ngModel)]="info.description_ar" type="text" class="form-control" (focus)="onFocus()">
                        </div>
                        <a class="vincent_button btnX" *ngIf="editImgS == true"
                          (click)="editImg(
                                    info.id,
                                    info.title,
                                    info.title_ar,
                                    info.description,
                                    info.description_ar)">
                                      تغير
                        </a>
                        <div class="status" *ngIf="loading == true">
                          <img src="assets/imgs/loading2.gif" class="status_cus">
                        </div>
                        <div class="status" *ngIf="done == true">
                          <img src="assets/imgs/done.png" class="status_cus">
                        </div>
                        <!-- <form #upDatePUrl (ngSubmit)=updatePhoto(info.id)>
                          <div class="md-form">
                            <p>   أختر الصورة   </p>
                            <input mdbInput type="file" ngModel #updatephotoUrl name="photoUrl" class="form-control" (focus)="onFocus_PhotoUpdateds()" required >
                          </div>
                          <input type="submit" value="تغير الصورة" class="vincent_button" *ngIf="upDatePUrl.invalid || PhotoUpdateds == true" style="margin-bottom: 25px;">
                          <div class="status" *ngIf="changePhotoLoading == true">
                            <img src="assets/imgs/loading2.gif"  class="status_cus">
                          </div>
                          <p *ngIf="PhotoUpdated == true">تم تغير الصورة</p>
                          <br>
                        </form> -->

                      </div>
                      <a class="vincent_button" (click)="deleteItem(info.id)">حذف اللوح</a>            
                    </div>
                    <div class="modal-footer">
                      <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2.hide()" mdbWavesEffect>غلق</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- edit item model end-->

              <!-- Show descriptions-->
              <div mdbModal #basicModal2222="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2222.hide()">
                        <span aria-hidden="true">×</span>
                      </button>
                      <h4 class="modal-title w-100" id="myModalLabel">وصف الصورة</h4>
                    </div>
                      <div class="modal-body" style="text-align:center">
                        <h5>{{info.description}}</h5>
                        <h5>{{info.description_ar}}</h5>                                    
                      </div> 
                      <div class="modal-footer">
                        <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2222.hide()" mdbWavesEffect>غلق</button>
                      </div>
                  </div>
               
                </div>
              </div>
              <!-- Show descriptions End-->
          
              <!-- Show name-->
              <div mdbModal #basicModal222233="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal222233.hide()">
                        <span aria-hidden="true">×</span>
                      </button>
                      <h4 class="modal-title w-100" id="myModalLabel">أسم الصورة</h4>
                    </div>
                      <div class="modal-body" style="text-align:center">
                          <h3>{{info.title}}</h3>         
                          <h3>{{info.title_ar}}</h3>
                      </div> 
                      <div class="modal-footer">
                        <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal222233.hide()" mdbWavesEffect>غلق</button>
                      </div>
                  </div>
              
                </div>
              </div>
              <!-- Show name End-->
      
          </tr>
      </tbody>
    </table>
      </div>
    </div>
  </div>